(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("js-data"), require("@bingads-webui/js-data-odata-base-adapter"), require("@bingads-webui/storage"));
	else if(typeof define === 'function' && define.amd)
		define(["bluebird", "underscore", "@bingads-webui-universal/primitive-utilities", "js-data", "@bingads-webui/js-data-odata-base-adapter", "@bingads-webui/storage"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("bluebird"), require("underscore"), require("@bingads-webui-universal/primitive-utilities"), require("js-data"), require("@bingads-webui/js-data-odata-base-adapter"), require("@bingads-webui/storage")) : factory(root["bluebird"], root["underscore"], root["@bingads-webui-universal/primitive-utilities"], root["js-data"], root["@bingads-webui/js-data-odata-base-adapter"], root["@bingads-webui/storage"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})((typeof self !== 'undefined' ? self : this), function(__WEBPACK_EXTERNAL_MODULE__6__, __WEBPACK_EXTERNAL_MODULE__7__, __WEBPACK_EXTERNAL_MODULE__8__, __WEBPACK_EXTERNAL_MODULE__67__, __WEBPACK_EXTERNAL_MODULE__124__, __WEBPACK_EXTERNAL_MODULE__152__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 149);
/******/ })
/************************************************************************/
/******/ ({

/***/ 124:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__124__;

/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(150);


/***/ }),

/***/ 150:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "PreferenceService", {
  enumerable: true,
  get: function get() {
    return _preferenceService.default;
  }
});

var _preferenceService = _interopRequireDefault(__webpack_require__(151));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _underscore = _interopRequireDefault(__webpack_require__(7));

var _bluebird = _interopRequireDefault(__webpack_require__(6));

var _storage = __webpack_require__(152);

var _primitiveUtilities = __webpack_require__(8);

var _dataStore = __webpack_require__(153);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const Level = {
  All: 0,
  User: 1,
  Account: 2
};
let isInitialized = false;
let localRepository = [];
let localAccountLevelRepository = [];
let localUserLevelRepository = [];
let p$preferences = null;
let keySessionStorage = null;
const localToRemoteIdMap = {};
const userLevelLocalToRemoteIdMap = {};
let latestLocalId = 0;

const resolvedPromise = _bluebird.default.resolve();

let remoteSyncTasks = resolvedPromise;
const SessionStorage = (0, _storage.getSessionStorage)();
let currentUserInfo;
let currentCustomerInfo;
let currentAccountInfo;
let APIHost;
let APIPath;
let oDataToken;
/**
 * Resolves when remote sync tasks is done. Will make use of
 * passed in ID after other optimizations, making it mandatory to pass
 * for that case.
 * @param {String} id - ID for data
 * @returns {Promise} - resolves when remote sync is done
 */

const onRemoteSyncDone = id => {
  if (!id) {
    throw new Error('Should pass the ID of the preference item to check');
  }

  return remoteSyncTasks;
};
/**
 * Resolves when remote sync tasks for multiple Ids is done. Will make use of
 * passed in IDs after other optimizations, making it mandatory to pass
 * for that case.
 * @param {String[]} ids - IDs for data
 * @returns {Promise} - resolves when remote sync is done
 */


const onMultipleRemoteSyncDone = ids => _bluebird.default.all(ids.map(id => onRemoteSyncDone(id)));

const getStoreOptions = (params, isUserLevel) => {
  const accountId = isUserLevel === true ? 0 : currentAccountInfo.Id;
  const customerId = currentCustomerInfo.Id;
  return {
    cacheResponse: false,
    entitySet: {
      odataURL: `/Customers(${customerId})/Accounts(${accountId})/Preferences`,
      $withKey: function withKey(id) {
        const odataURL = `${this.odataURL}(${id})`;
        return {
          odataURL
        };
      }
    },
    afterUpdate: (resource, attrs) => // OData Server should return the entity as response for PATCH
    // But it doesn't, so we hack here to use request body as the response
    _bluebird.default.resolve(_underscore.default.defaults({}, params, attrs)),
    host: APIHost,
    path: APIPath,
    oDataToken
  };
};

const concatLocalRepository = () => {
  if (_underscore.default.isArray(localUserLevelRepository) && localUserLevelRepository.length > 0) {
    localRepository = localUserLevelRepository.concat(localAccountLevelRepository);
  } else {
    localRepository = localAccountLevelRepository;
  }

  return localRepository;
};

const getSessionStorageKey = () => {
  const userName = currentUserInfo.Name || 'anonymous';
  const customerId = currentCustomerInfo.Id;
  return `Preferences_${userName}_${customerId}`;
};

const parseData = rawData => {
  let parsedData = null;

  try {
    parsedData = JSON.parse(rawData);
  } catch (e) {
    parsedData = rawData;
  }

  return parsedData;
};

const mapPreferenceData = rawPreferenceData => _underscore.default.map(rawPreferenceData, result => {
  result.Data = parseData(result.Data); // eslint-disable-line no-param-reassign

  return result;
});

const initSync = ({
  initialUserPreferences,
  currentUser,
  currentCustomer,
  currentAccount,
  apiHost,
  apiPath,
  authToken
}) => {
  if (localRepository.length === 0) {
    currentUserInfo = currentUser;
    currentCustomerInfo = currentCustomer;
    currentAccountInfo = currentAccount;
    APIHost = apiHost;
    APIPath = apiPath;
    oDataToken = authToken;
    const userLevelPreferenceFromPageContext = parseData(initialUserPreferences.UserLevelPreferences);
    const accountLevelPreferenceFromPageContext = parseData(initialUserPreferences.AccountLevelPreferences);

    if (_underscore.default.isArray(userLevelPreferenceFromPageContext) && _underscore.default.isArray(accountLevelPreferenceFromPageContext)) {
      localUserLevelRepository = mapPreferenceData(userLevelPreferenceFromPageContext);
      localAccountLevelRepository = mapPreferenceData(accountLevelPreferenceFromPageContext); // successfully initialized with data from page context

      isInitialized = true;
      concatLocalRepository();
    }
  }

  return localRepository;
};

const initialize = context => {
  if (!p$preferences) {
    const initialUserPreferences = context.initialUserPreferences,
          currentUser = context.currentUser,
          currentCustomer = context.currentCustomer,
          currentAccount = context.currentAccount,
          apiHost = context.apiHost,
          apiPath = context.apiPath,
          authToken = context.authToken;
    const repository = initSync({
      initialUserPreferences,
      currentUser,
      currentCustomer,
      currentAccount,
      apiHost,
      apiPath,
      authToken
    });

    if (isInitialized) {
      // repository has already been initialized, no need to call findAll()
      p$preferences = _bluebird.default.resolve().then(() => repository);
      return p$preferences;
    }

    currentUserInfo = currentUser;
    currentCustomerInfo = currentCustomer;
    currentAccountInfo = currentAccount;
    APIHost = apiHost;
    APIPath = apiPath;
    oDataToken = authToken;
    p$preferences = _bluebird.default.settle([_dataStore.preferenceDS.findAll({
      limit: Number.MAX_VALUE - 1,
      userLevel: false
    }, getStoreOptions()), _dataStore.preferenceDS.findAll({
      limit: Number.MAX_VALUE - 1,
      userLevel: true
    }, getStoreOptions({}, true))]).then(results => {
      if (results[1].isFulfilled()) {
        const resultUserPreferences = results[1].value();

        if (_underscore.default.isArray(resultUserPreferences)) {
          localUserLevelRepository = mapPreferenceData(resultUserPreferences);
        }
      }

      if (results[0].isFulfilled()) {
        const resultAccountPreferences = results[0].value();

        if (_underscore.default.isArray(resultAccountPreferences)) {
          localAccountLevelRepository = mapPreferenceData(resultAccountPreferences);
        }
      } // successfully initialized with async odata fetch


      isInitialized = true;
      return concatLocalRepository();
    });
  }

  if (!keySessionStorage) {
    keySessionStorage = getSessionStorageKey();
  }

  return p$preferences;
};

const findByPrefix = prefix => {
  if (!prefix) {
    return [];
  }

  const searchPattern = new RegExp(`^${prefix.replace(/\./g, '\\.')}`, 'i');
  return (0, _primitiveUtilities.cloneDeep)(_underscore.default.filter(localRepository, preference => searchPattern.test(preference.Name)));
};

const findByName = name => (0, _primitiveUtilities.cloneDeep)(_underscore.default.findWhere(localRepository, {
  Name: name
}));

const findByNameAtUserLevel = name => (0, _primitiveUtilities.cloneDeep)(_underscore.default.findWhere(localUserLevelRepository, {
  Name: name
}));

const findByNameAtAccountLevel = name => (0, _primitiveUtilities.cloneDeep)(_underscore.default.findWhere(localAccountLevelRepository, {
  Name: name
}));

const find = id => (0, _primitiveUtilities.cloneDeep)(_underscore.default.findWhere(localRepository, {
  Id: id
}));

const setToSession = data => {
  if (!data || !SessionStorage) {
    return _bluebird.default.resolve();
  }

  const sessionData = SessionStorage.get(keySessionStorage) || [];

  const preference = _underscore.default.findWhere(sessionData, {
    Name: data.Name
  });

  if (_underscore.default.isEmpty(preference)) {
    sessionData.push(data);
  } else {
    _underscore.default.extend(preference, data);
  }

  SessionStorage.set(keySessionStorage, sessionData);
  return _bluebird.default.resolve(sessionData);
};

const findByNameInSession = name => {
  const sessionData = SessionStorage.get(keySessionStorage);
  return _underscore.default.findWhere(sessionData, {
    Name: name
  });
};

const delFromSession = name => {
  if (!name || !SessionStorage) {
    return;
  }

  let sessionData = SessionStorage.get(keySessionStorage);
  sessionData = _underscore.default.reject(sessionData, {
    Name: name
  });
  SessionStorage.set(keySessionStorage, sessionData);
};
/**
 * Generate a local ID for keys created in this window.
 * Once data is persisted to remote, it will be mapped to the
 * remote ID for subsequent syncing.
 * @returns {String} - ID for data
 */


const generateLocalId = () => {
  latestLocalId += 1;
  return `localId_${latestLocalId}`;
};
/**
 * Replaces the Id parameter with the remote Id if it
 * was previously mapped
 * @param {Object} params - The params object to save
 * @param {Any} id - The local Id to replace
 * @param {Boolean} isUserLevel - True if it is a user level preference
 * @returns {undefined} - no returns
 */


const setRemoteId = (params, id, isUserLevel) => {
  if (!_underscore.default.isString(params.Id) || params.Id.indexOf('localId_') !== 0) {
    return;
  }

  const keyMap = isUserLevel ? userLevelLocalToRemoteIdMap : localToRemoteIdMap;
  params.Id = keyMap[id] || undefined; // eslint-disable-line no-param-reassign
};
/**
 * After a preference is destroyed, removes its ID mapping
 * @param {any} id - local ID
 * @param {any} isUserLevel - True if it is a user level preference
 * @returns {undefined} - no returns
 */


const deleteMappedId = (id, isUserLevel) => {
  const remoteIdMap = isUserLevel ? userLevelLocalToRemoteIdMap : localToRemoteIdMap;
  delete remoteIdMap[id];
};
/**
 * Adds a task for remote syncing to the queue
 * @param {Promise} task - Promise with some CUD operation
 * @returns {Promise} - The promise that will resolve once operation is done
 */


const addTask = task => {
  if (remoteSyncTasks !== resolvedPromise && remoteSyncTasks.isFulfilled()) {
    remoteSyncTasks = resolvedPromise;
  }

  remoteSyncTasks = remoteSyncTasks.then(task).catch(() => {// Remote call failed. Chain will continue;
  });
  return remoteSyncTasks;
};

const updateLocalCopy = (isUserLevel, id, data) => {
  const localCopy = isUserLevel === true ? localUserLevelRepository : localAccountLevelRepository;

  let preference = _underscore.default.findWhere(localCopy, {
    Id: id
  });

  if (_underscore.default.isEmpty(preference)) {
    preference = _underscore.default.defaults({
      Id: id
    }, data);
    localCopy.push(preference);
  } else {
    _underscore.default.extend(preference, data);
  }

  concatLocalRepository();
  return (0, _primitiveUtilities.cloneDeep)(preference);
};

const createOrUpdate = (data, level) => {
  if (!isInitialized) {
    return _bluebird.default.resolve(null);
  }

  const isUserLevel = level === Level.User;
  let currentPreference = [];

  if (level === Level.All) {
    currentPreference = findByName(data.Name);
  } else if (level === Level.User) {
    currentPreference = findByNameAtUserLevel(data.Name);
  } else if (level === Level.Account) {
    currentPreference = findByNameAtAccountLevel(data.Name);
  }

  if (currentPreference && _underscore.default.isEqual(currentPreference.Data, data.Data)) {
    return _bluebird.default.resolve(currentPreference);
  }

  if (currentPreference && !data.Id) {
    data.Id = currentPreference.Id; // eslint-disable-line no-param-reassign
  }

  const params = _underscore.default.defaults({
    // Data is in type String in OData Server
    Data: _underscore.default.isString(data.Data) ? data.Data : JSON.stringify(data.Data)
  }, _underscore.default.defaults(data, {
    Type: 'string',
    Version: 1
  }));

  const id = _underscore.default.isNull(data.Id) || _underscore.default.isUndefined(data.Id) ? generateLocalId() : data.Id;
  const preference = updateLocalCopy(isUserLevel, id, data);
  addTask(() => {
    setRemoteId(params, id, isUserLevel);
    return _dataStore.preferenceDS.create(params, getStoreOptions(params, isUserLevel)).then(ret => {
      const remoteIdMap = isUserLevel ? userLevelLocalToRemoteIdMap : localToRemoteIdMap;
      remoteIdMap[id] = ret.Id;
    });
  });
  return _bluebird.default.resolve(preference);
};

const set = data => createOrUpdate(data, Level.All);

const setAtUserLevel = data => createOrUpdate(data, Level.User);

const setAtAccountLevel = data => createOrUpdate(data, Level.Account);

const processBulkSetResponse = response => ({
  Action: 'BatchCreate',
  Response: response
});

const bulkCreate = (params, isUserLevel) => {
  if (!isInitialized) {
    return _bluebird.default.resolve(null);
  }

  const options = getStoreOptions(params, isUserLevel);
  options.bulkCreate = true;
  options.action = 'POST';
  options.processResponse = processBulkSetResponse;
  options.overrideResponse = true; // Make bulkCreate wait for other tasks to finish

  return addTask(() => _dataStore.preferenceDS.create(params, options).then(result => {
    if (!result || !result.Response || !_underscore.default.isArray(result.Response)) {
      return {
        Status: false,
        Response: result.Response
      };
    }

    let status = false;

    _underscore.default.forEach(result.Response, (item, index) => {
      if (item.status !== 200 || !item.data) {
        return;
      }

      status = true;
      const data = params.reqs[index];
      data.Data = parseData(data.Data);
      updateLocalCopy(isUserLevel, item.data.Id, data);
    });

    concatLocalRepository();
    return {
      Status: status,
      Response: result.Response
    };
  }));
};

const delFromStore = (id, isUserLevel) => {
  const params = {
    Id: id
  };

  if (isUserLevel === true) {
    localUserLevelRepository = _underscore.default.reject(localUserLevelRepository, {
      Id: id
    });
  } else {
    localAccountLevelRepository = _underscore.default.reject(localAccountLevelRepository, {
      Id: id
    });
  }

  concatLocalRepository();
  addTask(() => {
    setRemoteId(params, id, isUserLevel);
    return _dataStore.preferenceDS.destroy(params.Id, getStoreOptions({}, isUserLevel)).then(() => {
      deleteMappedId(id, isUserLevel);
    });
  });
  return _bluebird.default.resolve();
};

const del = id => delFromStore(id, false);

const delAtUserLevel = id => delFromStore(id, true);

var _default = {
  isInitialized,
  initSync,
  initialize,
  findByPrefix,
  findByName,
  find,
  set,
  setAtUserLevel,
  setAtAccountLevel,
  bulkCreate,
  del,
  setToSession,
  findByNameInSession,
  delFromSession,
  delAtUserLevel,
  findByNameAtUserLevel,
  findByNameAtAccountLevel,
  onRemoteSyncDone,
  onMultipleRemoteSyncDone
};
exports.default = _default;

/***/ }),

/***/ 152:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__152__;

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.preferenceDS = void 0;

var _jsData = _interopRequireDefault(__webpack_require__(67));

var _jsDataOdataBaseAdapter = __webpack_require__(124);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const dataStore = new _jsData.default.DS({
  cacheResponse: false
});
dataStore.registerAdapter('odata', new _jsDataOdataBaseAdapter.ODataBaseAdapter({}), {
  default: true
});
const preferenceDS = dataStore.defineResource({
  name: 'Preference',
  idAttribute: 'Id' // Customized on the idAttribute

});
exports.preferenceDS = preferenceDS;

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__6__;

/***/ }),

/***/ 67:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__67__;

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__7__;

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__8__;

/***/ })

/******/ });
});
